module.exports = __webpack_public_path__ + "img/y- (20).fee6ee6b.png";